module.exports = __webpack_public_path__ + "static/media/zb.f3af4eff.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zb.png
// module id = 2146
// module chunks = 6